__turbopack_context__.v({
  "btnVoltaraoTopo": "QiCg7q_btnVoltaraoTopo",
  "show": "QiCg7q_show",
});
